// KO UI catalogue.
// __I18N_PENDING__: values are not yet translated and fall back to English at runtime.
export default {
  'site.header.apartments': '아파트 및 호텔',
  'site.currency': '통화',
  'site.language': '언어',
  'site.currencySelector': '통화 선택',
  'site.languageSelector': '언어 선택',
  'site.menu': '메뉴',
  'site.signIn': '로그인',
  'site.signOut': '로그아웃',
  'site.signOutConfirmTitle': '__I18N_PENDING__:Sign out?',
  'site.signOutConfirmBody': '__I18N_PENDING__:Are you sure you want to sign out?',
  'site.signOutStay': '__I18N_PENDING__:Stay signed in',
  'site.openMenu': '메뉴 열기',
  'site.footer.copyright': '모든 권리 보유.',
  'site.footer.manageBooking': '예약 관리',
  'site.footer.terms': '이용약관',
  'site.footer.privacy': '개인정보 처리방침',
  'site.trust.bestPrice': '최저가 보장',
  'site.trust.bestPriceDesc': '최저가로 예약하세요.',
  'site.trust.flexibleBooking': '유연한 예약',
  'site.trust.flexibleBookingDesc': '변경 및 취소가 쉬워요.',
  'site.trust.securePayments': '안전한 결제',
  'site.trust.securePaymentsDesc': '안전한 결제 시스템.',
  'site.trust.localSupport': '현지 지원',
  'site.trust.localSupportDesc': '언제든 도와드릴게요.',
  'home.heroTitle': '최적의 숙소를 찾아보세요',
  'home.inAustralia': '호주에서',
  'home.heroSubtitle': '어떤 여행에도 어울리는 아파트와 호텔',
  'home.errorLoading': '숙소를 불러올 수 없습니다.',
  'home.noPropertiesTitle': '현재 이용 가능한 숙소가 없습니다.',
  'home.noPropertiesDescription': '원하는 목적지를 검색하여 이용 가능한 숙소를 찾아보세요.',
  'home.exploreStays': '숙소 둘러보기',
  'home.property': '숙소',
  'home.property_one': '숙소',
  'home.property_other': '숙소',
  'home.properties': '숙소',
  'home.foundInAustralia': '호주에서 찾음',
  'search.errorLoading': '예약 가능 여부를 불러올 수 없습니다. 다시 시도해주세요.',
  'search.noResults': '검색 조건에 맞는 숙소가 없습니다.',
  'search.mapFollow': '지도를 움직이면서 검색',
  'search.chooseLocationTitle': '위치를 선택하세요',
  'search.chooseLocationDescription': '예약 가능한 숙소를 검색하기 전에 목적지를 선택하세요.',
  'search.chooseDatesTitle': '날짜를 선택하세요',
  'search.pastCheckIn': '체크인 날짜는 과거일 수 없습니다.',
  'search.checkOutAfterCheckIn': '체크아웃은 체크인 이후여야 합니다.',
  'search.property': '숙소',
  'search.property_one': '숙소',
  'search.property_other': '숙소',
  'search.properties': '숙소',
  'search.found': '검색됨',
  'widget.where': '어디로',
  'widget.location': '위치',
  'widget.checkInOut': '체크인 / 체크아웃',
  'widget.guests': '숙박 인원',
  'widget.rooms': '객실',
  'widget.promoCode': '프로모션 코드',
  'widget.promoPlaceholderCompact': '코드 입력 (선택)',
  'widget.promoPlaceholder': '선택사항',
  'widget.search': '검색',
  'widget.update': '__I18N_PENDING__:Update',
  'widget.adult': '성인',
  'widget.adults': '성인',
  'widget.child': '어린이',
  'widget.children': '어린이',
  'widget.decreaseAdults': '성인 줄이기',
  'widget.increaseAdults': '성인 늘리기',
  'widget.decreaseChildren': '어린이 줄이기',
  'widget.increaseChildren': '어린이 늘리기',
  'widget.room': '객실',
  'widget.adultOption': '성인 {count}명',
  'widget.adultOption_one': '성인 {count}명',
  'widget.adultOption_other': '성인 {count}명',
  'widget.childOption': '어린이 {count}명',
  'widget.childOption_one': '어린이 {count}명',
  'widget.childOption_other': '어린이 {count}명',
  'widget.roomOption': '객실 {count}개',
  'widget.roomOption_one': '객실 {count}개',
  'widget.roomOption_other': '객실 {count}개',
  'widget.guestCount': '__I18N_PENDING__:{count} guests',
  'widget.guestCount_one': '__I18N_PENDING__:{count} guest',
  'widget.guestCount_other': '__I18N_PENDING__:{count} guests',
  'widget.roomCount': '__I18N_PENDING__:{count} rooms',
  'widget.roomCount_one': '__I18N_PENDING__:{count} room',
  'widget.roomCount_other': '__I18N_PENDING__:{count} rooms',
  'widget.locationError': '위치 정보를 불러올 수 없습니다. 다시 시도해주세요.',
  'widget.searchAria': '예약 가능 여부 검색',
  'widget.dateErrorRequired': '체크인과 체크아웃 날짜를 모두 선택하세요.',
  'widget.dateErrorPast': '체크인 날짜는 과거일 수 없습니다.',
  'widget.dateErrorRange': '체크아웃은 체크인 이후여야 합니다.',
  'widget.dateRange.placeholder': '체크인 및 체크아웃 날짜 선택',
  'widget.dateRange.selectCheckout': '체크아웃 선택',
  'widget.dateRange.aria.checkIn': '체크인',
  'widget.dateRange.aria.checkOut': '체크아웃',
  'widget.dateRange.aria.picker': '체크인 / 체크아웃 기간 선택',
  'widget.dateRange.previousMonth': '이전 달',
  'widget.dateRange.nextMonth': '다음 달',
  'widget.dateRange.selectCheckIn': '체크인 날짜 선택',
  'widget.dateRange.selectCheckOut': '체크아웃 날짜 선택',
  'widget.dateRange.resetToday': '오늘로 초기화',
  'widget.dateRange.done': '완료',
  'property.heroAlt': '숙소 대표 이미지',
  'property.fallbackName': '{site}의 선택된 숙소',
  'property.chooseRoom': '객실 선택',
  'property.filterBy': '필터:',
  'property.filterAll': '전체 객실',
  'property.filterStudios': '스튜디오',
  'property.filter1Bed': '1베드룸',
  'property.filter2Bed': '2베드룸',
  'property.filterApartments': '아파트',
  'property.sortBy': '정렬:',
  'property.sortRecommended': '추천',
  'property.sortPriceLow': '가격 낮은 순',
  'property.sortPriceHigh': '가격 높은 순',
  'property.errorLoading': '예약 가능 여부를 불러올 수 없습니다. 다시 시도해주세요.',
  'property.noRooms': '이용 가능한 객실이 없습니다',
  'property.noRoomsDescription': '다른 날짜나 인원으로 검색해보세요.',
  'property.totalForNights': '{nights}박 총액',
  'property.perNight': '1박 기준',
  'property.night': '박',
  'property.night_one': '박',
  'property.night_other': '박',
  'property.nights': '박',
  'property.freeCancellation': '무료 취소',
  'property.selectRoom': '객실 선택',
  'property.selected': '선택됨',
  'property.continue': '계속',
  'property.previousPhoto': '이전 사진',
  'property.nextPhoto': '다음 사진',
  'property.addToWishlist': '찜하기 추가',
  'property.popularChoice': '인기 선택',
  'property.showMore': '더 보기',
  'property.showLess': '접기',
  'property.maxOccupancy': '최대 수용 인원:',
  'property.size': '크기:',
  'property.bedType': '침대 유형:',
  'property.roomAmenities': '객실 편의시설',
  'property.showMoreAmenities': '+{count}개 더',
  'property.guests': '숙박 인원',
  'property.adults': '성인',
  'property.children': '어린이',
  'property.onlyRoomsLeft': '남은 객실 {count}개',
  'property.onlyRoomsLeft_one': '남은 객실 {count}개',
  'property.onlyRoomsLeft_other': '남은 객실 {count}개',
  'property.lastBookedMinutes': '마지막 예약 {count}분 전',
  'property.lastBookedMinutes_one': '마지막 예약 {count}분 전',
  'property.lastBookedMinutes_other': '마지막 예약 {count}분 전',
  'property.lastBookedHours': '마지막 예약 {count}시간 전',
  'property.lastBookedHours_one': '마지막 예약 {count}시간 전',
  'property.lastBookedHours_other': '마지막 예약 {count}시간 전',
  'property.lastBookedDays': '마지막 예약 {count}일 전',
  'property.lastBookedDays_one': '마지막 예약 {count}일 전',
  'property.lastBookedDays_other': '마지막 예약 {count}일 전',
  'property.checkInTime': '체크인 {time}',
  'property.checkOutTime': '체크아웃 {time}',
  'property.compare': '비교',
  'property.taxesIncluded': '1박 기준, 세금 및 수수료 포함',
  'property.chooseRate': '요금 선택',
  'property.yourSelection': '선택 사항',
  'property.aboutRoom': '객실 정보',
  'property.roomDetails': '객실 상세',
  'property.selectedProperty': '__I18N_PENDING__:Selected property by {site}',
  'property.backToRooms': '객실 목록으로',
  'property.standardRate': '스탠다드 요금',
  'property.noPromotion': '이 요금에 적용 가능한 프로모션이 없습니다.',
  'property.youSave': '{percent}% 할인 - {amount} 절약',
  'property.inclusions': '포함 사항:',
  'property.viewAllPhotos': '모든 사진 보기',
  'property.seeOnMap': '지도에서 보기',
  'room.perNight': '박',
  'room.sleeps': '수용 인원',
  'room.thumbnailAlt': '__I18N_PENDING__:Thumbnail',
  'room.available': '예약 가능',
  'room.select': '선택',
  'room.selected': '선택됨',
  'card.viewAvailability': '예약 가능 여부 보기',
  'card.from': '부터',
  'card.night': '박',
  'card.checkAvailability': '예약 가능 여부 확인',
  'card.saveToFavourites': '찜 목록에 저장',
  'card.ratingExcellent': '매우 좋음',
  'card.ratingVeryGood': '좋음',
  'card.ratingGood': '양호',
  'card.ratingGuest': '투숙객 평점',
  'guest.stepChooseRoom': '객실 선택',
  'guest.stepGuestDetails': '투숙객 정보',
  'guest.stepPayment': '결제',
  'guest.stepConfirmation': '예약 완료',
  'guest.title': '투숙객 정보 입력',
  'guest.subtitle': '예약 정보를 입력해주세요.',
  'guest.firstName': '이름',
  'guest.lastName': '성',
  'guest.email': '이메일',
  'guest.emailHint': '예약 확인 이메일이 이 주소로 발송됩니다.',
  'guest.country': '국가',
  'guest.selectCountry': '국가 선택',
  'guest.searchCountry': '국가 검색…',
  'guest.loadingCountries': '국가 불러오는 중…',
  'guest.loadingSuburbs': '__I18N_PENDING__:Loading suburbs…',
  'guest.noSuburbsFound': '__I18N_PENDING__:No suburbs found',
  'guest.selectedSuburb': '__I18N_PENDING__:Selected: {suburb}',
  'guest.postalCode': '우편번호',
  'guest.phone': '전화번호',
  'guest.phoneCountryCode': '__I18N_PENDING__:Country code',
  'guest.phonePlaceholder': '전화번호 입력',
  'guest.address': '주소',
  'guest.city': '도시',
  'guest.specialRequests': '특별 요청 (선택)',
  'guest.specialRequestsPlaceholder': '특별 요청 사항이 있으신가요?',
  'guest.termsPrefix': '예약을 완료함으로써 저의',
  'guest.terms': '이용약관',
  'guest.termsAnd': '및',
  'guest.privacy': '개인정보 처리방침',
  'guest.termsSuffix': '에 동의하고 예약 조건을 수락합니다.',
  'guest.marketingOptOut': '마케팅 메시지를 받고 싶지 않습니다.',
  'guest.cardVerify': '1 {currency}의 임시 카드 승인이 진행됩니다. 지금은 결제되지 않습니다.',
  'guest.chargeNow': '__I18N_PENDING__:Your card will be charged {amount} now.',
  'guest.payOnArrival': '현장에서 결제됩니다.',
  'guest.noRoomsSelected': '선택된 객실이 없습니다.',
  'guest.noPropertySelected': '선택된 숙소가 없습니다.',
  'guest.paymentStillLoading': '결제 옵션을 불러오는 중입니다. 잠시 후 다시 시도해주세요.',
  'guest.submitProcessing': '처리 중…',
  'guest.submitVerifyCard': '카드 확인 및 예약 확정',
  'guest.submitConfirm': '예약 확정',
  'checkout.backToRooms': '__I18N_PENDING__:Back to room selection',
  'checkout.bookingSummary': '__I18N_PENDING__:Your booking summary',
  'checkout.noRooms': '__I18N_PENDING__:No rooms in this booking — add one below.',
  'checkout.edit': '__I18N_PENDING__:Edit',
  'checkout.remove': '__I18N_PENDING__:Remove',
  'checkout.removeTitle': '__I18N_PENDING__:Remove this room?',
  'checkout.removeBody':
    "__I18N_PENDING__:{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': '__I18N_PENDING__:Cancel',
  'checkout.removeConfirm': '__I18N_PENDING__:Remove room',
  'checkout.duration': '__I18N_PENDING__:Duration of stay',
  'checkout.occupancy': '__I18N_PENDING__:Occupancy',
  'checkout.occupancyValue': '__I18N_PENDING__:{adults} Adults, {children} Children',
  'checkout.ratePlan': '__I18N_PENDING__:Rate Plan',
  'checkout.policies': '__I18N_PENDING__:Cancellation & Payment Policies',
  'checkout.roomRequests': '__I18N_PENDING__:Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    '__I18N_PENDING__:Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': '__I18N_PENDING__:Sub Total',
  'checkout.accommodationFees':
    '__I18N_PENDING__:Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': '__I18N_PENDING__:Taxes & fees',
  'checkout.memberSavings': '__I18N_PENDING__:Member savings',
  'checkout.promotionSavings': '__I18N_PENDING__:Savings',
  'checkout.total': '__I18N_PENDING__:Total',
  'checkout.totalCaption': '__I18N_PENDING__:Includes taxes & fees',
  'checkout.propertyCurrencyTitle':
    '__I18N_PENDING__:Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "__I18N_PENDING__:Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': '__I18N_PENDING__:Add another room',
  'checkout.memberTitle': '__I18N_PENDING__:Join as a member now — membership is free',
  'checkout.memberTitleWithSaving':
    '__I18N_PENDING__:Join as a member now — save {amount} on this booking',
  'checkout.memberBody': '__I18N_PENDING__:Member discounts apply before you pay.',
  'checkout.memberJoin': '__I18N_PENDING__:Join free',
  'checkout.memberSignIn': '__I18N_PENDING__:Sign in',
  'checkout.memberJoinInline': '__I18N_PENDING__:Join as a member using the details above',
  'checkout.memberJoinInlineHint':
    '__I18N_PENDING__:Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': '__I18N_PENDING__:Member total',
  'checkout.memberSaveCaption': '__I18N_PENDING__:You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': '__I18N_PENDING__:Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    '__I18N_PENDING__:Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': '__I18N_PENDING__:Proceed to payment',
  'checkout.processing': '__I18N_PENDING__:Processing your booking…',
  'checkout.processingDoNotClose':
    '__I18N_PENDING__:Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose':
    '__I18N_PENDING__:Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': '__I18N_PENDING__:Applying member rates to your stay…',
  'checkout.loadingProfile': '__I18N_PENDING__:Loading your member details…',
  'checkout.preparingPayment': '__I18N_PENDING__:Preparing secure payment…',
  'checkout.termsHint':
    '__I18N_PENDING__:The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "__I18N_PENDING__:You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment':
    '__I18N_PENDING__:Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '__I18N_PENDING__:{checkIn} – {checkOut} • {nights} nights',
  'payment.title': '결제',
  'payment.method': '결제 수단',
  'payment.cardDetailsHint':
    '아래에 카드 정보를 안전하게 입력하세요. 카드 정보는 토큰화되어 당사 서버에 저장되지 않습니다.',
  'payment.loadingForm': '결제 양식 불러오는 중…',
  'payment.formUnavailable': '결제 양식을 사용할 수 없습니다.',
  'payment.acceptTerms': '이용약관 및 취소 정책에 동의합니다.',
  'payment.payNow': '지금 결제',
  'payment.processing': '처리 중…',
  'payment.noRoomsSelected': '선택된 객실이 없습니다.',
  'payment.redirecting': '안전한 결제 페이지로 이동 중…',
  'payment.notConfigured': '이 숙소에는 Quickstream이 설정되지 않았습니다.',
  'payment.noScript': 'Quickstream 결제 서비스를 불러올 수 없습니다. 페이지를 새로고침해주세요.',
  'payment.formNotLoaded': '결제 양식을 불러오지 못했습니다. 페이지를 새로고침해주세요.',
  'payment.cardDetails': '결제에 실패했습니다. 카드 정보를 확인해주세요.',
  'payment.tokenizationFailed': '카드 토큰화에 실패했습니다. 다시 시도해주세요.',
  'payment.failed': '결제에 실패했습니다.',
  'payment.statusResult': '결제 상태: {status}. 다시 시도해주세요.',
  'confirmation.loading': '예약 정보를 불러오는 중…',
  'confirmation.notFound': '예약을 찾을 수 없습니다. 예약 번호를 확인하고 다시 시도해주세요.',
  'confirmation.errorGeneric': '예약을 확정할 수 없습니다. 고객센터에 문의해주세요.',
  'confirmation.errorLoadDetails': '예약 상세 정보를 불러올 수 없습니다.',
  'confirmation.couldNotComplete': '결제를 완료할 수 없습니다',
  'confirmation.startNew': '새 예약 시작',
  'confirmation.tryPaymentAgain': '__I18N_PENDING__:Try payment again',
  'confirmation.paymentNotFound': '결제 세션을 찾을 수 없습니다. 고객센터에 문의해주세요.',
  'confirmation.paymentStateInvalid': '결제가 완료 가능한 상태가 아닙니다. 다시 시작해주세요.',
  'confirmation.paymentFailedDeclined':
    '결제를 완료할 수 없습니다. 카드 정보를 확인하거나 다른 결제 수단을 사용해주세요.',
  'confirmation.paymentTimeout': '결제 시간이 초과되었습니다. 다시 시도해주세요.',
  'confirmation.paymentGatewayUnavailable':
    '결제 시스템이 일시적으로 사용 불가능합니다. 잠시 후 다시 시도해주세요.',
  'confirmation.paymentUnknown': '결제를 확정할 수 없습니다: {message}.',
  'confirmation.paymentGenericError':
    '결제를 확정할 수 없습니다. 다시 시도하거나 고객센터에 문의해주세요.',
  'summary.title': '예약 요약',
  'summary.yourBooking': '예약 요약',
  'summary.noRoomsSelected': '아직 선택된 객실이 없습니다.',
  'summary.checkIn': '체크인',
  'summary.checkOut': '체크아웃',
  'summary.lengthOfStay': '숙박 기간',
  'summary.guests': '숙박 인원',
  'summary.nights': '{nights}박',
  'summary.nights_one': '{nights}박',
  'summary.nights_other': '{nights}박',
  'summary.totalForNights': '{nights}박 총액',
  'summary.includingTaxes': '세금 및 수수료 포함',
  'summary.discount': '{amount} 할인',
  'summary.checkInFrom': '__I18N_PENDING__:From {time}',
  'summary.checkOutUntil': '__I18N_PENDING__:Until {time}',
  'summary.cancellationUntil': '__I18N_PENDING__:until {date}',
  'detail.confirmed': '예약 확정!',
  'detail.received': '예약 접수됨',
  'detail.referenceIntro': '예약 번호는',
  'detail.reservationId': '예약 번호:',
  'detail.processing': '예약이 처리 중입니다. 결제가 확인되면 확인 이메일을 보내드릴게요.',
  'detail.guest': '투숙객',
  'detail.rooms': '객실',
  'detail.night': '박',
  'detail.nights': '박',
  'detail.adult': '성인',
  'detail.adults': '성인',
  'detail.child': '어린이',
  'detail.infant': '유아',
  'detail.priceBreakdown': '가격 내역',
  'detail.subtotal': '소계',
  'detail.taxes': '세금',
  'detail.fees': '수수료',
  'detail.discounts': '할인',
  'detail.surcharge': '카드 수수료',
  'detail.grandTotal': '총 합계',
  'priceBreakdown.roomSubtotal': '객실 소계',
  'priceBreakdown.total': '합계',
  'detail.deposit': '보증금',
  'detail.depositDueBy': '까지 입금',
  'detail.arrival': '도착',
  'detail.specialRequests': '특별 요청',
  'detail.backToHome': '홈으로',
  'detail.confirmationSentTo': '__I18N_PENDING__:A confirmation email has been sent to',
  'detail.bookingReference': '__I18N_PENDING__:Booking reference',
  'detail.address': '__I18N_PENDING__:Address',
  'detail.guestDetails': '__I18N_PENDING__:Guest details',
  'detail.name': '__I18N_PENDING__:Name',
  'detail.email': '__I18N_PENDING__:Email',
  'detail.phone': '__I18N_PENDING__:Mobile number',
  'detail.status': '__I18N_PENDING__:Status',
  'detail.card': '__I18N_PENDING__:Card',
  'detail.paidInFull': '__I18N_PENDING__:Paid in full',
  'detail.partiallyPaid': '__I18N_PENDING__:Partially paid',
  'detail.paidOnline': '__I18N_PENDING__:Paid online',
  'detail.dueAtProperty': '__I18N_PENDING__:Due at property',
  'detail.bookedOn': '__I18N_PENDING__:Booked on',
  'detail.roomTotal': '__I18N_PENDING__:Room total',
  'detail.roomsCount': '__I18N_PENDING__:Rooms ({count})',
  'detail.yourRoom': '__I18N_PENDING__:Your room',
  'detail.roomNumber': '__I18N_PENDING__:Room {number}',
  'detail.priceSummary': '__I18N_PENDING__:Price summary',
  'detail.chargedInPropertyCurrency': '__I18N_PENDING__:Charged in property currency ({currency})',
  'detail.totalPaid': '__I18N_PENDING__:Total paid',
  'detail.plansChanged': '__I18N_PENDING__:Plans changed?',
  'detail.plansChangedBody':
    '__I18N_PENDING__:Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': '__I18N_PENDING__:Print confirmation',
  'detail.questions':
    '__I18N_PENDING__:Questions? Reply to your confirmation email or contact the property directly.',
  'shared.retry': '다시 시도',
  'shared.close': '닫기',
  'shared.back': '뒤로',
  'shared.previous': '이전',
  'shared.next': '다음',
  'validation.firstNameRequired': '이름을 입력해주세요.',
  'validation.lastNameRequired': '성을 입력해주세요.',
  'validation.emailRequired': '올바른 이메일을 입력해주세요.',
  'validation.phoneRequired': '전화번호를 입력해주세요.',
  'validation.addressRequired': '주소를 입력해주세요.',
  'validation.cityRequired': '도시를 입력해주세요.',
  'validation.countryRequired': '국가를 선택해주세요.',
  'validation.postalCodeRequired': '우편번호를 입력해주세요.',
  'error.pmsUnavailable':
    '선택하신 날짜에 해당 객실이 더 이상 예약 가능하지 않습니다. 다른 날짜나 객실을 선택해주세요.',
  'error.pmsSyncError': '숙소 시스템에 연결할 수 없습니다. 잠시 후 다시 시도해주세요.',
  'error.paymentNotConfigured':
    '이 숙소에는 결제 설정이 되어 있지 않습니다. 다른 숙소를 선택하거나 고객센터에 문의해주세요.',
  'error.paymentStartFailed': '결제 시작 중 문제가 발생했습니다. 다시 시도해주세요.',
  'error.bookingFailed': '예약에 실패했습니다. 다시 시도해주세요.',
  'error.quoteAlreadyConverted':
    '__I18N_PENDING__:This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    '__I18N_PENDING__:A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',
  'site.title.default': '숙소 예약',
  'site.title.suffix': '아파트 및 호텔',
  'site.title.home': '홈',
  'site.title.search': '검색',
  'site.title.property': '숙소',
  'site.title.room': '객실',
  'site.title.guestDetails': '투숙객 정보',
  'site.title.payment': '결제',
  'site.title.confirmation': '예약 확정',
  'site.title.bookingLookup': '예약 조회',
  'site.title.bookingDetails': '예약 상세',
  'site.title.cancellation': '예약 취소',
  'site.title.reservationDetail': '예약 상세',
  'site.title.signIn': '로그인',
  'site.title.signUp': '회원가입',
  'site.title.notFound': '페이지를 찾을 수 없습니다',
  'notFound.title': '페이지를 찾을 수 없습니다',
  'notFound.message': '찾으시는 페이지가 존재하지 않습니다.',
  'notFound.backHome': '홈으로',
  'home.heroAlt': '호주 도시 스카이라인',
  'home.featuredProperties': '추천 숙소',
  'home.popularDestinations': '인기 여행지',
  'common.reviews': '{count}개의 리뷰',
  'common.reviews_one': '{count}개의 리뷰',
  'common.reviews_other': '{count}개의 리뷰',
  'common.loading': '불러오는 중',
  'common.pleaseWait': '__I18N_PENDING__:Please wait while we load your results',
  'common.of': '/',
  'common.select': '선택…',
  'common.search': '검색…',
  'common.selectLocation': '위치 선택',
  'location.propertyCount': '__I18N_PENDING__:{count} properties',
  'location.propertyCount_one': '__I18N_PENDING__:{count} property',
  'location.propertyCount_other': '__I18N_PENDING__:{count} properties',
  'location.roomsAvailable': '__I18N_PENDING__:{count} rooms available',
  'location.roomsAvailable_one': '__I18N_PENDING__:{count} room available',
  'location.roomsAvailable_other': '__I18N_PENDING__:{count} rooms available',
  'map.suburb.newstead': '__I18N_PENDING__:Newstead',
  'map.suburb.fortitudeValley': '__I18N_PENDING__:Fortitude Valley',
  'map.suburb.paddington': '__I18N_PENDING__:Paddington',
  'map.suburb.bardon': '__I18N_PENDING__:Bardon',
  'map.suburb.brisbane': '__I18N_PENDING__:Brisbane',
  'map.suburb.southBrisbane': '__I18N_PENDING__:South Brisbane',
  'map.suburb.kangarooPoint': '__I18N_PENDING__:Kangaroo Point',
  'map.suburb.stLucia': '__I18N_PENDING__:St Lucia',
  'map.suburb.moorooka': '__I18N_PENDING__:Moorooka',
  'map.suburb.annerley': '__I18N_PENDING__:Annerley',
  'map.suburb.mtGravatt': '__I18N_PENDING__:Mt Gravatt',
  'common.noOptions': '이용 가능한 옵션이 없습니다',
  'common.code': '코드',
  'common.searchCode': '코드 검색…',
  'filter.title': '필터',
  'filter.price': '가격',
  'filter.priceMinimum': '최소',
  'filter.priceMaximum': '최대',
  'filter.priceMinPlaceholder': '₩0',
  'filter.priceMaxPlaceholder': '₩500,000+',
  'filter.propertyType': '숙소 유형',
  'filter.propertyType.hotel': '호텔',
  'filter.propertyType.apartment': '아파트',
  'filter.propertyType.resort': '리조트',
  'filter.amenities': '편의시설',
  'filter.amenity.pool': '수영장',
  'filter.amenity.parking': '주차',
  'filter.amenity.breakfast': '조식 포함',
  'filter.rating': '등급',
  'filter.rating.any': '모든 등급',
  'filter.rating.5': '5성',
  'filter.rating.4': '4성 이상',
  'filter.rating.3': '3성 이상',
  'filter.more': '더 보기',
  'filter.more.freeCancellation': '무료 취소',
  'filter.more.payAtProperty': '현장 결제',
  'filter.clear': '초기화',
  'filter.apply': '필터 적용',
  'card.reviews_one': '리뷰',
  'card.reviews_other': '리뷰',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': '__I18N_PENDING__:show more',
  'card.showLess': '__I18N_PENDING__:show less',
  'widget.childrenAgeHint': '0 - 12세',
  'auth.orContinueWith': '또는 다음으로 계속',
  'auth.signIn.title': '계정에 로그인',
  'auth.signIn.subtitle':
    '다시 오신 것을 환영합니다! 로그인하여 예약을 관리하고, 숙소를 확인하며 특별 혜택을 누려보세요.',
  'auth.email': '이메일',
  'auth.emailPlaceholder': '이메일 주소 입력',
  'auth.emailRequired': '이메일을 입력해주세요.',
  'auth.emailInvalid': '올바른 이메일 주소를 입력해주세요.',
  'auth.password': '비밀번호',
  'auth.passwordPlaceholder': '비밀번호 입력',
  'auth.createPasswordPlaceholder': '비밀번호 생성',
  'auth.passwordRequired': '비밀번호를 입력해주세요.',
  'auth.passwordMinLength': '비밀번호는 최소 {min}자 이상이어야 합니다.',
  'auth.passwordPattern': '비밀번호에는 문자와 숫자가 포함되어야 합니다.',
  'auth.passwordHint': '최소 {min}자 이상의 문자, 숫자, 기호를 조합해 사용하세요.',
  'auth.showPassword': '비밀번호 보기',
  'auth.hidePassword': '비밀번호 숨기기',
  'auth.keepSignedIn': '로그인 상태 유지',
  'auth.forgotPassword': '비밀번호를 잊으셨나요?',
  'auth.forgot.title': '__I18N_PENDING__:Reset your password',
  'auth.forgot.subtitle':
    '__I18N_PENDING__:Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': '__I18N_PENDING__:Send reset link',
  'auth.forgot.sending': '__I18N_PENDING__:Sending...',
  'auth.forgot.success':
    '__I18N_PENDING__:If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': '__I18N_PENDING__:Back to sign in',
  'auth.reset.title': '__I18N_PENDING__:Choose a new password',
  'auth.reset.subtitle': '__I18N_PENDING__:Enter a new password for your account.',
  'auth.reset.submit': '__I18N_PENDING__:Reset password',
  'auth.reset.saving': '__I18N_PENDING__:Resetting...',
  'auth.reset.success':
    '__I18N_PENDING__:Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken':
    '__I18N_PENDING__:This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.title': '__I18N_PENDING__:Verify your email',
  'auth.verify.verifying': '__I18N_PENDING__:Verifying your email address…',
  'auth.verify.success':
    '__I18N_PENDING__:Your email address has been verified. You can sign in now.',
  'auth.verify.error': '__I18N_PENDING__:We could not verify this link.',
  'auth.verify.missingToken':
    '__I18N_PENDING__:This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    '__I18N_PENDING__:The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.resend': '__I18N_PENDING__:Resend verification email',
  'auth.verify.sending': '__I18N_PENDING__:Sending email…',
  'auth.verify.resent':
    '__I18N_PENDING__:Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': '로그인',
  'auth.signingIn': '로그인 중…',
  'auth.signInError': '로그인에 실패했습니다. 다시 시도해주세요.',
  'auth.googleError': 'Google 로그인에 실패했습니다.',
  'auth.noAccount': '계정이 없으신가요?',
  'auth.createAccount': '계정 만들기',
  'auth.signUp.title': '계정 만들기',
  'auth.signUp.subtitle':
    '{site}에 가입하여 예약을 관리하고, 즐겨찾는 숙소를 저장하고, 특별 혜택을 받아보세요.',
  'auth.firstName': '이름',
  'auth.firstNamePlaceholder': '이름 입력',
  'auth.firstNameRequired': '이름을 입력해주세요.',
  'auth.lastName': '성',
  'auth.lastNamePlaceholder': '성 입력',
  'auth.lastNameRequired': '성을 입력해주세요.',
  'auth.mobile': '휴대전화 번호',
  'auth.mobilePlaceholder': '휴대전화 번호 입력',
  'auth.dialingCode': '국가 번호',
  'auth.mobileRequired': '휴대전화 번호를 입력해주세요.',
  'auth.mobileInvalid': '올바른 휴대전화 번호를 입력해주세요.',
  'auth.confirmPassword': '비밀번호 확인',
  'auth.confirmPasswordPlaceholder': '비밀번호 확인',
  'auth.termsAgree': '다음에 동의합니다',
  'auth.termsRequired': '이용약관 및 개인정보 처리방침에 동의해야 합니다.',
  'auth.marketingConsent': '{site}의 특별 혜택과 여행 영감을 이메일로 받고 싶습니다.',
  'auth.signUpError': '계정을 생성할 수 없습니다. 다시 시도해주세요.',
  'auth.signUp': '회원가입',
  'auth.creatingAccount': '계정 생성 중…',
  'auth.createAccountButton': '계정 만들기',
  'auth.alreadyHaveAccount': '이미 계정이 있으신가요?',
  'auth.passwordMismatch': '비밀번호가 일치하지 않습니다.',
  'pricing.title': '가격 요약',
  'pricing.noRoomsSelected': '선택된 객실이 없습니다. 뒤로 가서 객실을 선택해주세요.',
  'pricing.backToAvailability': '예약 가능 여부로',
  'pricing.continue': '투숙객 정보 입력으로',
  'property.youSavePercent': '{percent}% 할인',
  'property.includingTaxesFees': '(세금 및 수수료 포함)',
  'map.zoomIn': '확대',
  'map.zoomOut': '축소',
  'map.viewFullMap': '전체 지도 보기',
  'booking.progress': '예약 진행',
  'reservationDetail.resetAria': '예약 상태 초기화',
  'bookingLookup.title': '예약 조회',
  'bookingLookup.description': '예약 번호와 이메일을 입력하여 예약을 확인, 변경 또는 취소하세요.',
  'bookingLookup.bookingReference': '예약 번호',
  'bookingLookup.placeholder': '예: SYD-260815-0001',
  'bookingLookup.lookingUp': '조회 중…',
  'bookingLookup.findBooking': '예약 조회',
  'bookingLookup.notFound':
    '예약을 찾을 수 없습니다. 예: BK-2026-001, alex.morgan@example.com, Morgan을 시도해보세요.',
  'cancellation.title': '예약 취소',
  'cancellation.property': '숙소',
  'cancellation.details': '취소 상세',
  'cancellation.penalty': '취소 수수료',
  'cancellation.refund': '환불 금액',
  'cancellation.totalPaid': '총 결제 금액:',
  'cancellation.reasonLabel': '취소 사유 (선택)',
  'cancellation.understand': '이 작업은 되돌릴 수 없음을 이해합니다.',
  'cancellation.cancelledDemo':
    '이 UI 데모에서 예약이 취소되었습니다. 환불 금액: {{refundAmount}}.',
  'cancellation.confirm': '취소 확정',
  'cancellation.notFound': '예약을 찾을 수 없습니다.',
  'bookingDetails.title': '예약 상세',
  'bookingDetails.notFound': '예약을 찾을 수 없습니다.',
  'bookingDetails.checkIn': '체크인:',
  'bookingDetails.checkOut': '체크아웃:',
  'bookingDetails.rooms': '객실',
  'bookingDetails.guest': '투숙객',
  'bookingDetails.freeCancellationUntil': '{date}까지 무료 취소 가능',
  'bookingDetails.total': '총액:',
  'reservationDetail.loading': '예약 정보를 불러오는 중…',
  'reservationDetail.noReference': '예약 번호가 제공되지 않았습니다.',
  'reservationDetail.loadError': '예약 상세 정보를 불러올 수 없습니다.',
  'site.footer.brand': 'BookYourStay',
  'common.loadingLocations': '위치 불러오는 중…',
  'common.couldNotLoadLocations': '위치를 불러올 수 없습니다',
  'common.searchLocationPlaceholder': '국가, 도시 또는 숙소 검색',
  'common.collapse': '접기',
  'common.expand': '펼치기',
  'map.loadingGoogle': 'Google 지도 불러오는 중…',
  'map.errorGoogle': 'Google 지도를 불러올 수 없습니다',
  'map.errorMap': '지도를 불러올 수 없습니다.',
  'map.greatLocation': '최고의 위치',
  'home.trust.secureBooking': '안전한 예약',
  'home.trust.secureBookingDesc': '고객님의 정보는 안전하게 보호됩니다.',
  'home.trust.bestPrice': '최저가 보장',
  'home.trust.bestPriceDesc': '더 낮은 가격을 찾으셨나요? 맞춰드리겠습니다.',
  'home.trust.localSupport': '24시간 지원',
  'home.trust.localSupportDesc': '언제든 도와드릴게요.',
  'home.trust.flexibleBooking': '유연한 옵션',
  'home.trust.flexibleBookingDesc': '선택한 요금에 무료 취소가 제공됩니다.',
  'promotion.memberPromo': '회원 프로모션',
  'promotion.save': '할인',
  'property.memberRate': '회원 요금',
  'property.hideAmenities': '편의시설 숨기기',
  'property.showAllAmenities': '모든 편의시설 보기',
  'property.chooseRatePromo': '원하는 요금을 선택하세요 - 회원 요금으로 특별 할인을 받으세요!',
  'roomRate.stepChooseStay': '__I18N_PENDING__:Choose your stay',
  'roomRate.stepCheckout': '__I18N_PENDING__:Checkout',
  'roomRate.stepConfirmation': '__I18N_PENDING__:Confirmation',
  'roomRate.membersSaveUpTo': '__I18N_PENDING__:Members save up to {percent}%',
  'roomRate.membersSaveMore': '__I18N_PENDING__:Members save more',
  'roomRate.memberSignInHint':
    '__I18N_PENDING__:Sign in or join free during checkout to unlock member rates.',
  'roomRate.from': '__I18N_PENDING__:FROM',
  'roomRate.perNightSuffix': '__I18N_PENDING__:/ night',
  'roomRate.nonMemberFrom': '__I18N_PENDING__:Non-member rate from {price}',
  'roomRate.taxesIncluded': '__I18N_PENDING__:Rates include taxes & fees',
  'roomRate.taxesExcluded': '__I18N_PENDING__:Rates exclude taxes & fees',
  'roomRate.inclTaxes': '__I18N_PENDING__:incl. taxes & fees',
  'roomRate.exclTaxes': '__I18N_PENDING__:excl. taxes & fees',
  'roomRate.includesTaxes': '__I18N_PENDING__:Includes taxes and fees',
  'roomRate.excludesTaxes': '__I18N_PENDING__:Excludes taxes and fees',
  'roomRate.bookNow': '__I18N_PENDING__:Book now',
  'roomRate.selectRate': '__I18N_PENDING__:Select this rate',
  'roomRate.bestValue': '__I18N_PENDING__:Best Value',
  'roomRate.onlyLeftAtPrice': '__I18N_PENDING__:Only {count} left at this price',
  'roomRate.fullDetails': '__I18N_PENDING__:Full room details',
  'roomRate.loadMoreRates': '__I18N_PENDING__:Load more rates',
  'roomRate.showLessRates': '__I18N_PENDING__:Show less rates',
  'roomRate.vsNonMemberTotal': '__I18N_PENDING__:vs non-member total of {total}',
  'roomRate.youSave': '__I18N_PENDING__:You save {amount} ({percent}% off)',
  'roomRate.totalForNights': '__I18N_PENDING__:{total} total • {nights} nights',
  'roomRate.nightTimes': '__I18N_PENDING__:{nights} nights × {perNight}',
  'roomRate.totalLine': '__I18N_PENDING__:{total} total • {taxNote}',
  'roomRate.notMemberYet':
    '__I18N_PENDING__:Not a member yet? Join during checkout — the member price still applies.',
  'roomRate.promoApplied': '__I18N_PENDING__:Promo {code} applied',
  'roomRate.promotions': '__I18N_PENDING__:Promotions',
  'roomRate.promoSaveSuffix': '__I18N_PENDING__:Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': '__I18N_PENDING__:Save - {amount}',
  'roomRate.promoStayPaySuffix': '__I18N_PENDING__:Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': '__I18N_PENDING__:Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': '__I18N_PENDING__:Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': '__I18N_PENDING__:Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': '__I18N_PENDING__:Special rate — {rate} per night',
  'roomRate.memberLocked': '__I18N_PENDING__:Member-only promotion',
  'roomRate.memberUnlockTitle': '__I18N_PENDING__:Sign in or join to unlock',
  'roomRate.memberUnlockSaving': '__I18N_PENDING__:member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': '__I18N_PENDING__:Member rate includes',
  'roomRate.memberBenefitRatesTitle': '__I18N_PENDING__:Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody':
    '__I18N_PENDING__:Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': '__I18N_PENDING__:Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': '__I18N_PENDING__:Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    '__I18N_PENDING__:Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': '__I18N_PENDING__:Free to join',
  'roomRate.memberBenefitJoinBody':
    '__I18N_PENDING__:Create an account in seconds during checkout.',
  'roomRate.joinFree': '__I18N_PENDING__:Join free',
  'roomRate.joinFreeCta': '__I18N_PENDING__:Sign in or join free',
  'roomRate.alreadyMember': '__I18N_PENDING__:Already a member?',
  'roomRate.alreadyMemberHint': '__I18N_PENDING__:Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': '__I18N_PENDING__:View other room types',
  'roomRate.view': '__I18N_PENDING__:View',
  'roomRate.freeCancelUntil': '__I18N_PENDING__:Free cancellation until {date}',
  'roomRate.upsell': '__I18N_PENDING__:Recommended alternative',
  'roomRate.roomsIncluded': '__I18N_PENDING__:{count} rooms included',
  'roomRate.nightlyBreakdown': '__I18N_PENDING__:Night-by-night price',
  'roomRate.previousRate': '__I18N_PENDING__:Previous rate',
  'roomRate.nextRate': '__I18N_PENDING__:Next rate',
  'card.discount': '{percent}% 할인',
  'gallery.imageAlt': '{title} {current}/{total}번째 뷰',
  'gallery.thumbnailAlt': '{current}/{total}번째 뷰로 이동',
  'gallery.previewAlt': '{title} 미리보기',
  'detail.night_one': '박',
  'detail.night_other': '박',
  'detail.adult_one': '성인',
  'detail.adult_other': '성인',
  'detail.child_one': '어린이',
  'detail.child_other': '어린이',
  'detail.infant_one': '유아',
  'detail.infant_other': '유아',
} as const;
